import { TaskColor, keys as colors } from '@config/colors/task';
import { keys as icons } from '@components/icons/task';
import { Option } from '@contexts/dropdowns/types';

export const variant: Record<TaskColor, string> = {
  amber: 'bg-task-amber-500',
  aqua: 'bg-task-aqua-500',
  blue: 'bg-task-blue-500',
  ['blue-secondary']: 'bg-task-blue-secondary-500',
  brown: 'bg-task-brown-500',
  cyan: 'bg-task-cyan-500',
  green: 'bg-task-green-500',
  indigo: 'bg-task-indigo-500',
  lime: 'bg-task-lime-500',
  orange: 'bg-task-orange-500',
  ['orange-secondary']: 'bg-task-orange-secondary-500',
  pink: 'bg-task-pink-500',
  ['pink-secondary']: 'bg-task-pink-secondary-500',
  purple: 'bg-task-purple-500',
  ['purple-secondary']: 'bg-task-purple-secondary-500',
  steel: 'bg-task-steel-500',
  stone: 'bg-task-stone-500',
  yellow: 'bg-task-yellow-500',
};

export const options: Option[] = [
  ...colors.map((el) => ({ name: el, value: el })),
  ...icons.map((el) => ({ name: el, value: el })),
];
